const buttons = () =>
  <NodeListOf<HTMLElement>>document.querySelectorAll(".js-sub-topics-button");

const positionButtonIcon = (button: HTMLElement) => {
  const label = button.querySelector(".js-sub-topics-label");
  const icon = button.querySelector(".js-sub-topics-icon");

  if (!(label instanceof HTMLElement) || !(icon instanceof SVGElement)) {
    return;
  }

  icon.style.left = `${label.getBoundingClientRect().width}px`;
  icon.style.right = "auto";
};

const buttonsTick = () => buttons().forEach(positionButtonIcon);

buttonsTick();
window.addEventListener("load", buttonsTick);
window.addEventListener("resize", buttonsTick);
